import { styled } from 'styled-components';

const InfoContainer = styled.div`
  display: grid;
  min-width: 120px;
  padding: 24px 0;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: center;
  gap: 24px 12px;
  flex-wrap: wrap;
  border-radius: 12px;
  grid-template-columns: repeat(2, 1fr);
  max-width: 100%;
  width: 100%;

  @media (min-width: 769px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 48px 24px;
    max-width: 100%;
  }
`;

const InfoItemContainer = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  filter: drop-shadow(0px 3px 3px rgba(18, 22, 32, 0.3));

  @media (min-width: 769px) {
    flex-direction: row;
    padding: 0px 24px;
    align-items: center;
    align-content: center;
    gap: 32px 16px;
  }
`;

const InfoItemImg = styled.div`
  display: flex;
  width: 36px;
  height: 36px;
  justify-content: center;
  align-items: center;
  filter: drop-shadow(0px 3px 3px rgba(18, 22, 32, 0.3));

  @media (min-width: 769px) {
    width: 54px;
    height: 54px;
  }
`;

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const InfoItemText = styled.div`
  color: #fff;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 19.6px */

  @media (min-width: 769px) {
    font-size: 16px;
  }
`;

export {
  InfoContainer,
  InfoItemContainer,
  InfoItemImg,
  InfoItemText,
  StyledImage,
};